import type { SVGProps } from 'react';

const ArrowBack = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.16667 3.16669L3.16667 6.00002L6.16667 8.83335"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66666 6.00006H10.1667C11.6394 6.00006 12.8333 7.19399 12.8333 8.66673V12.8334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowBack;
